
import Account from "../../../../assets/user/Account";
import Dashboard from "../../../../assets/user/Dashboard";
import KYC from "../../../../assets/user/KYC";
import Wallet from "../../../../assets/Wallet";
import Transfer from "../../../../assets/user/Transfer";
import Tutorial from "../../../../assets/user/Tutorial";
import Transaction from "../../../../assets/user/Transaction";
import Support from "../../../../assets/user/Support";
import Faq from "../../../../assets/user/Faq";
import Disc from "../../../../assets/user/Disc";
import Reports from "../../../../assets/user/Reports";
import Download from "../../../../assets/Download";
import { LuPencilRuler } from "react-icons/lu";
export const getSidebarData = (userDetails) => {
    console.log("Sidebar userDetails:", userDetails);
    const copyTradingAllowedEmails = [
        "karanbha127@proton.me",
        "ir149174@gmail.com",
        "chiragofficial8800@gmail.com",
        "test@yopmail.com",
        "asdf@gmc.com",
        "xxy@gmail.com",
    ];
    const normalizedUserEmail = userDetails?.email?.trim()?.toLowerCase();
    const canViewCopyTrading = copyTradingAllowedEmails.includes(normalizedUserEmail);

    return [
    {
        title: 'Dashboard',
        icon: <Dashboard />,
        url: '/dashboard',
        activeUrl: ['/dashboard'],
        kycApproval: true
    },
    // {
    //     title: 'Inbox',
    //     icon: <EmailTemplate />,
    //     url: '/inbox',
    //     activeUrl: ['/inbox'],
    //     kycApproval: true
    // },
    {
        title: 'Accounts',
        icon: <Account />,
        url: '/accounts',
        activeUrl: ['/accounts', '/account', '/trades'],
        kycApproval: true
    },
    ...(canViewCopyTrading
        ? [{
            title: 'Copy Trading',
            icon: <LuPencilRuler size={22} />,
            activeUrl: [],
            kycApproval: true,
            child: [
                {
                    title: 'Copy Trading',
                    icon: <Disc />,
                    url: '/copy_trading',
                    activeUrl: ['/copy_trading'],
                },
                {
                    title: 'Leaderboard',
                    icon: <Disc />,
                    url: '/leaderboard',
                    activeUrl: ['/leaderboard'],
                },
            ],
        }]
        : []),
    // {
    //     title: 'Deposit',
    //     icon: <Withdraw />,
    //     url: '/deposit',
    //     activeUrl: ['/deposit', '/deposit_usdt'],
    //     kycApproval: true
    // },
    // {
    //     title: 'Withdraw',
    //     icon: <Withdraw />,
    //     url: '/withdraw',
    //     activeUrl: ['/withdraw'],
    //     kycApproval: true
    // },
    {
        title: 'Wallet',
        icon: <Wallet />,
        activeUrl: [],
        kycApproval: true,
        child: [
            {
                title: 'Deposit',
                icon: <Disc />,
                url: '/deposit',
                activeUrl: ['/deposit', '/deposit_usdt'],
            },
            {
                title: 'Withdraw',
                icon: <Disc />,
                url: '/withdraw',
                activeUrl: ['/withdraw'],
            },
            // {
            //     title: 'Cash Deposit',
            //     icon: <Disc />,
            //     url: '/cash_deposit',
            //     activeUrl: ['/cash_deposit'],
            // },
        ],
    },
    {
        title: 'Transfer',
        icon: <Transfer />,
        url: '/transfer',
        activeUrl: ['/transfer'],
        kycApproval: true
    },
    {
        title: 'My Transaction',
        icon: <Transaction />,
        url: '/my_transaction',
        activeUrl: ['/my_transaction'],
        kycApproval: true
    },
    // {
    //     title: 'Parent Tree',
    //     icon: <MyTeam />,
    //     url: '/perent_tree',
    //     activeUrl: ['/perent_tree'],
    //     kycApproval: true
    // },
    {
        title: 'Reports',
        icon: <Reports />,
        activeUrl: [],
        kycApproval: true,
        child: [
            {
                title: 'Deposit',
                icon: <Disc />,
                url: '/deposit_Report',
                activeUrl: ['/deposit_Report'],
            },
            {
                title: 'Withdraw',
                icon: <Disc />,
                url: '/withdrawal_Report',
                activeUrl: ['/withdrawal_Report'],
            },
            {
                title: 'Transfer',
                icon: <Disc />,
                url: '/transfer_Report',
                activeUrl: ['/transfer_Report'],
            },
            {
                title: 'Logs',
                icon: <Disc />,
                url: '/logs',
                activeUrl: ['/logs'],
            },

        ],
    },
    {
        title: 'KYC',
        icon: <KYC />,
        url: '/kyc',
        activeUrl: ['/kyc'],
        unAuth: true,
    },
    {
        title: 'Tutorial',
        icon: <Tutorial />,
        url: '/tutorials',
        activeUrl: ['/tutorials']
    },
    {
        title: 'MT5 Download',
        icon: <Download />,
        url: '/download',
        activeUrl: ['/download']
    },
    {
        title: 'Support',
        icon: <Support />,
        url: '/support',
        activeUrl: ['/support', '/view_ticket']
    },
    {
        title: 'FAQs',
        icon: <Faq />,
        url: '/faq',
        activeUrl: ['/faq']
    },

];
};

export const SidebarData = getSidebarData();